import { useTranslation } from 'i18n';
import { logger } from 'monitor';
import { forwardRef } from 'react';
import { Switch } from 'ui';

import { useNetworkStatus } from '../../hooks/useNetworkStatus/useNetworkStatus';

export const NetworkOverrideSwitch = forwardRef<HTMLButtonElement>((_props, ref) => {
  const { t } = useTranslation('features');
  const { setMode: setNetworkOverrideMode, mode: networkOverrideMode } = useNetworkStatus();

  const isChecked = networkOverrideMode === 'offline';

  const handleModeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const nextMode = e.target.checked ? 'offline' : 'auto';
    logger.info('Network override mode changed', {
      nextMode,
      previousMode: networkOverrideMode,
    });
    setNetworkOverrideMode(nextMode);
  };
  return (
    <Switch
      label={t('networkStatus.override.label')}
      ref={ref}
      data-testid="network-override-switch"
      checked={isChecked}
      onChange={handleModeChange}
    />
  );
});

NetworkOverrideSwitch.displayName = 'NetworkOverrideSwitch';
